import { object, string } from 'yup';

import { VALIDATION_FIRST_NAME, VALIDATION_LAST_NAME } from '@uplift/validations';

export const inviteManagerFormValidation = object({
  firstName: VALIDATION_FIRST_NAME.required('Enter manager’s first name'),
  lastName: VALIDATION_LAST_NAME.required('Enter manager’s last name'),
  role: string().required('Select a role'),
  email: string().email('Enter valid email address').required('Enter email address'),
});

export const transferOwnershipValidation = object({
  newOwnerId: string().required('This field is required'),
  prevOwnerId: string(),
  prevOwnerNewRole: string().required('Select a role'),
});
